export default "__VITE_ASSET__BkHtw8uf__"